var _react_refresh_temp_1, _react_refresh_temp_2;
_react_refresh_temp_1 = $RefreshSig$();
_react_refresh_temp_2 = $RefreshSig$();
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getRootLogger } from '@lucidlink/tscore';
import { useLucidSdk } from '#context';
import { UserConfigKeyFactory } from '#query-hooks';
const getUserLoginConfigQueryKey = (userEmail, workspaceName) => workspaceName
    ? UserConfigKeyFactory.byEmailAndWorkspaceName(userEmail, workspaceName)
    : UserConfigKeyFactory.byEmail(userEmail);
export const useGetUserLoginConfig = (userEmail, workspaceName) => {
    _react_refresh_temp_1();
    const { lucidSdk } = useLucidSdk();
    const query = useQuery({
        queryKey: getUserLoginConfigQueryKey(userEmail, workspaceName),
        queryFn: async () => {
            try {
                return await lucidSdk
                    .publicClient()
                    .getUserLoginConfig(userEmail, workspaceName);
            }
            catch (error) {
                getRootLogger().error({ err: error, email: userEmail }, 'User login config fetch failed');
                throw error;
            }
        },
    });
    return query;
};
_react_refresh_temp_1(useGetUserLoginConfig, "H/nX1eMsJ0bsH20/D0j9QAs2SDk=", false, () => [useLucidSdk, useQuery]);
/**
 *  @description
 *  There are some instances when we want to fetch this
 *  data in an imperative matter, but still preserve
 *  the caching of react query.
 */
export const useImperativeGetUserLoginConfig = ({ onError, onSuccess, } = {}) => {
    _react_refresh_temp_2();
    const { lucidSdk } = useLucidSdk();
    const queryClient = useQueryClient();
    const mutation = useMutation({
        mutationFn: async ({ userEmail, workspaceName, }) => {
            return queryClient.fetchQuery({
                queryKey: getUserLoginConfigQueryKey(userEmail, workspaceName),
                queryFn: async () => lucidSdk
                    .publicClient()
                    .getUserLoginConfig(userEmail, workspaceName),
            });
        },
        onSuccess: (data) => {
            if (typeof onSuccess === 'function') {
                onSuccess(data);
            }
        },
        onError: (error, { userEmail }) => {
            if (typeof onError === 'function') {
                onError(error);
            }
            getRootLogger().error({ err: error, email: userEmail }, 'User login config fetch failed');
        },
    });
    return mutation;
};
_react_refresh_temp_2(useImperativeGetUserLoginConfig, "s074ag8lSG2K0z8InO7Yl75Raxc=", false, () => [useLucidSdk, useQueryClient, useMutation]);
